// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttontext{margin:0}.linkedbutton{text-decoration:underline;min-width:75px;height:25px;padding:0;font-size:inherit;margin:0;color:var(--button-color)}.linkedbutton:hover{color:var(--highlight-color);cursor:pointer}.linkedbutton:link{color:var(--button-color)}.linkedbutton:disabled{background-color:grey}", ""]);
// Exports
module.exports = exports;
